'use client'

import {abbreviateNumber} from '@app/components/search-section/search-result-card/helper'
import {useGameLiked} from '../actions-section/buttons/like-dislike-btns/game-like-provider/game-liked-context'

type Props = {
  text: string
}

const RealtimeRatingAndVotes = ({text}: Props) => {
  const {likeState} = useGameLiked()
  const {likeCount, dislikeCount} = likeState.counts

  const totalVotes = likeCount + dislikeCount
  const rating = totalVotes === 0 ? 0 : (likeCount / totalVotes) * 5
  return (
    <span>
      {rating.toFixed(1)} ({abbreviateNumber(likeState.counts.dislikeCount + likeState.counts.likeCount, false)} {text})
    </span>
  )
}

export default RealtimeRatingAndVotes
